import React, { Component } from 'react';
import { RootState } from '../../../../redux/store';
import { changeChart, changeChartEditorOptions } from '../../../../redux/actions/ChartActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { ChartState } from '../../../../redux/reducers/ChartReducer';
import { Syntax } from '@trlogic/ui-pack';
import ChartElasticExpressionComponent from '../metrics/ChartElasticExpressionComponent';
import LanguageUtil from '../../../../util/LanguageUtil';

class GlobalFilterContainer extends Component<Props> {
  render() {
    const {
      chart: { chartEditorOptions, expressionVariables },
    } = this.props;
    if (chartEditorOptions.globalFilterItem == undefined) return null;

    return (
      <div className={'flex flex-col gap-y-2 w-full px-3 py-3 h-auto '} id='expression_builder_global_filter'>
        <p className={'font-semibold text-primary '}>{LanguageUtil.get({ id: 'common.label.filter', defaultMessage: 'Filter' })}</p>
        <ChartElasticExpressionComponent
          id={'global_filter'}
          syntax={chartEditorOptions.globalFilterItem.syntax}
          variables={expressionVariables}
          onChangeSyntax={this.onChangeSyntax}
        />
      </div>
    );
  }

  private onChangeSyntax = (syntax: Syntax) => {
    const {
      chart: { chartEditorOptions },
      changeChartEditorOptions,
    } = this.props;
    if (chartEditorOptions.globalFilterItem == null) return;
    chartEditorOptions.globalFilterItem!.syntax = syntax;
    changeChartEditorOptions(chartEditorOptions);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  chart: state.chart as ChartState,
});
const mapDispatchToProps = { changeChart, changeChartEditorOptions };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(GlobalFilterContainer);
